<button mat-icon-button class="close-button" mat-dialog-close>
  <mat-icon class="close-icon">close</mat-icon>
</button>
<h3 mat-dialog-title align="center">Filtrar Activos</h3>

<mat-dialog-content class="filter-container">

    
    <mat-form-field appearance="fill" class="tipo-busqueda">
      <mat-label>Tipo de Busqueda</mat-label>
      <mat-select required [(ngModel)]="tipoBuscar" class="tipoBuscar">
        <mat-option value="Igual">Igual a</mat-option>
        <mat-option value="Contiene">Contiene</mat-option>
        <mat-option value="Mayor">Mayor que</mat-option>
        <mat-option value="Menor">Menor que</mat-option>
        <mat-option value="Intervalo">En un Intervalo</mat-option>
        <mat-option value="Coordenadas">Por Coordenadas</mat-option>
      </mat-select>
      <mat-hint *ngIf="formId==''&& (tipoBuscar=='Igual'|| tipoBuscar=='Contiene'||tipoBuscar=='Mayor'||tipoBuscar=='Menor'||tipoBuscar=='Intervalo')">Seleccione espacio de trabajo</mat-hint>
    <br>
  </mat-form-field>
    <br>
    <mat-form-field *ngIf="tipoBuscar!='Coordenadas'" appearance="fill" class="campo-id">
      <mat-label>Campo</mat-label>
      <mat-select required [(ngModel)]="campoId">
        <mat-option *ngFor="let field of fields; let i=index" value="{{field.formulario_campo_id}}">{{field.formulario_campo_nombre}}</mat-option>
      </mat-select>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill" class="valor-busqueda">
        <mat-label *ngIf="tipoBuscar=='Intervalo'">Valor Menor</mat-label>
        <mat-label *ngIf="tipoBuscar!='Intervalo'&&tipoBuscar!='Coordenadas'">Valor</mat-label>
        <mat-label *ngIf="tipoBuscar=='Coordenadas'">Latitud</mat-label>
        <input matInput type="search" required [(ngModel)]="valorBuscar">
        <button *ngIf="tipoBuscar!='Intervalo'&&tipoBuscar!='Coordenadas'" mat-button matSuffix mat-icon-button (click)=search()>
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    <br>
      <mat-form-field appearance="fill" class="valor-busqueda2" *ngIf="tipoBuscar=='Intervalo'||tipoBuscar=='Coordenadas'">
        <mat-label *ngIf="tipoBuscar=='Intervalo'">Valor Mayor</mat-label>
        <mat-label *ngIf="tipoBuscar=='Coordenadas'">Longitud</mat-label>
        <input matInput type="search" required [(ngModel)]="valorBuscar2">
        <button mat-button matSuffix mat-icon-button (click)=search()>
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>

      
<!-- TABLA RESULTADOS -->
<div class="resultados">
<mat-spinner *ngIf="loading" mode="indeterminate" class="spinner"></mat-spinner>
    <table mat-table #table [dataSource]="dataSource">
  
      <!-- Field1 Column -->
      <ng-container matColumnDef="campo1">
        <th mat-header-cell *matHeaderCellDef> {{defCampo1}} </th>
        <td type="text" mat-cell *matCellDef="let element"> {{element.campo1}} </td>
      </ng-container>
  
      <!-- Field_Filter Column -->
      <ng-container matColumnDef="campo2">
        <th mat-header-cell *matHeaderCellDef> {{defCampo2}} </th>
        <td type="text" mat-cell *matCellDef="let element"> {{element.campo2}} </td>
      </ng-container>
  
      <!-- Ubication Column -->
      <ng-container matColumnDef="ubicacion">
        <th mat-header-cell *matHeaderCellDef> Ubicación </th>
        <td type="text" mat-cell *matCellDef="let element"> {{element.latitud}}, {{element.longitud}} </td>
      </ng-container>
    
      <!-- Boton para ver el activo -->
      <ng-container matColumnDef="boton">
    <th mat-header-cell *matHeaderCellDef> Ver </th>
    <td type="text" mat-cell *matCellDef="let element">
      <button mat-icon-button (click)="cargarEscena(element.scene, element.x, element.y)">
        <mat-icon>pin_drop</mat-icon>
      </button>  
    </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSize]="5" showFirstLastButtons hidePageSize></mat-paginator>
  </div>
      
</mat-dialog-content>